import { useCallback, useState } from 'react';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';

const isMicrosoftLinked = (): boolean =>
  FirebaseAuthenticationClient.getProviderData()?.some((provider) => provider?.providerId === 'microsoft.com') ?? false;

type Result = {
  microsoftLinked: boolean;
  refreshMicrosoftLinked: () => Promise<void>;
};

export const useMicrosoftLinked = (): Result => {
  const [microsoftLinked, setMicrosoftLinked] = useState<boolean>(isMicrosoftLinked);

  const refreshMicrosoftLinked = useCallback(async () => {
    await FirebaseAuthenticationClient.reloadCurrentUser();
    setMicrosoftLinked(isMicrosoftLinked());
  }, []);

  return { microsoftLinked, refreshMicrosoftLinked };
};
